// extracted by mini-css-extract-plugin
export default {"container":"bTJuAneHJlTN_gqFtUQO","heading":"NkVL3aRt1rXjzQPBiSHT","volumeContainer":"JkCimI8cApX7aYOWmucA","volumeText":"uyI3YuBUIn3lHmV29zOU","volumeSlider":"n8lhXEOmdqiN4essXrAX"};